<template>
  <div :class="['py-5', classes]">
    <block-header
      :title="block.title"
      :subtitle="block.subtitle"
      :description="block.description"
      v-if="showHeader(block.__component)"
    />
    <component
      v-bind:is="parseComponent"
      :id="block.id"
      :block-type="block['__component']"
      :user-id="userId"
      :header="{ title: block.title, subTitle: block.subtitle }"
      :text="block.description"
      :title="block.title"
      :subtitle="block.subtitle"
      :description="block.description"
      :image-text="block.description"
      :image="block.media ? block.media.url : ''"
      :image-position="this.block.position ? this.block.position : ''"
      :alt-text="block.alt_text"
      :caption="block.caption"
      :video-id="block.wistia_code"
      :accordions="block.accordion_item"
      :quote-image="
        block.quote_item
          ? block.quote_item[0].author_image && block.quote_item[0].author_image.url
          : ''
      "
      :quote-image-alt-text="block.quote_item ? block.quote_item[0].alt_text : ''"
      :quote-text="block.quote_item ? block.quote_item[0].quote : ''"
      :quote-name="block.quote_item ? block.quote_item[0].author_name : ''"
      :quote-detail="block.quote_item ? block.quote_item[0].author_title : ''"
      :quote-reference="block.quote_item ? block.quote_item[0].reference : ''"
      :quotes="block.quote_item ? block.quote_item : []"
      :prompt="block.prompts ? block.prompts[0] : []"
      :prompts="block.prompts ? block.prompts : []"
      :question="block.question"
      :page-id="this.$route.query.page ? this.$route.query.page : '1'"
      :is-in-modal="isInModal"
      unit-type="miu"
      :unit-id="$route.params.elementId"
    />
    <accordion-block
      v-if="block.Transcription && block.Transcription.length > 0"
      :accordions="block.Transcription"
    />
    <div class="d-flex justify-content-end mt-3" v-if="block.prompts">
      <privacy-alert
        buttonSize="sm"
        :popupContent="trans('global.only_you_content')"
        :popupButton="trans('global.more_info')"
        :popupHref="{ name: 'privacy-legend' }"
        :popoverId="`block-${block.id}`"
        v-bind:targetBlank="true"
        pill
      >
        <img src="/images/icon_private.svg" width="24px" class="pr-1" />
        {{ trans("global.only_you") }}
      </privacy-alert>
    </div>

    <emotions
      v-if="showReactions"
      class="mt-3"
      :identity="block.id"
      :emotion-list="activeReactionList"
      :selected-emotion="existSelectedReaction ? existSelectedReaction.id : null"
      :button-text="buttonValue"
      @emotionChange="reactionChange($event)"
      @buttonClicked="reactionButtonClicked"
    />
    <ul
      v-if="showReactions && existSelectedReaction"
      id="reactions-counter"
      class="d-flex justify-content-end list-inline unstyled mt-3"
    >
      <template v-for="(reaction, idReaction) in blockReactionsCounters(block.id)">
        <li
          v-if="reaction.total > 0"
          class="d-flex list-inline-item small font-weight-bold mx-0"
          :class="{ 'text-secondary': reaction.id === existSelectedReaction.id }"
          :key="idReaction"
        >
          {{ getReaction(+idReaction).icon }}
          <span class="float-left pl-1">{{ reaction.total }}</span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import BlockHeader from "../molecules/BlockHeader";
import TextWithImageHorizontal from "./stream-page/blocks/TextWithImageHorizontal";
import TextWithImageVertical from "./stream-page/blocks/TextWithImageVertical";
import Infographic from "./stream-page/blocks/Infographic";
import TextBlock from "./stream-page/blocks/TextBlock";
import AccordionBlock from "./stream-page/blocks/AccordionBlock";
import QuoteBlock from "./stream-page/blocks/QuoteBlock";
import WistiaVideo from "./master-page/blocks/WistiaVideo";
import QuoteCarouselBlock from "./stream-page/blocks/QuoteCarouselBlock";
import PromptGroupHorizontal from "./master-page/PromptGroupHorizontal";
import PromptGroup from "./stream-page/PromptGroup";
import Checklist from "./master-page/blocks/Checklist";
import TitleBlock from "./stream-page/blocks/TitleBlock";
import MultiMeBlock from "./stream-page/blocks/MultiMeBlock";
import CollectiveRoomBlock from "./stream-page/blocks/CollectiveRoomBlock";
import PrivacyAlert from "../molecules/PrivacyAlert";
import Emotions from "../molecules/Emotions";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "StreamBlockContainer",
  components: {
    BlockHeader,
    TextWithImageHorizontal,
    TextWithImageVertical,
    Infographic,
    TextBlock,
    AccordionBlock,
    QuoteBlock,
    WistiaVideo,
    QuoteCarouselBlock,
    PromptGroupHorizontal,
    PromptGroup,
    Checklist,
    TitleBlock,
    MultiMeBlock,
    CollectiveRoomBlock,
    PrivacyAlert,
    Emotions,
  },
  props: {
    classes: String,
    block: Object,
    userId: Number,
    isInModal: Boolean,
  },
  methods: {
    ...mapActions({
      submitActivity: "streams/submitActivity",
      deleteActivity: "streams/deleteActivity",
    }),
    ...mapMutations({
      setBlockReactions: "moodsAndReactions/setBlockReactions",
    }),
    showHeader(blockComponent) {
      return (
        blockComponent !== "atoms.image" &&
        blockComponent !== "atoms.text" &&
        blockComponent !== "prompts.prompts-block" &&
        blockComponent !== "atoms.title" &&
        blockComponent !== "atoms.infographic"
      );
    },
    async reactionChange(reaction) {
      let details = [];

      if (this.reactionValid(reaction.id)) {
        details.push({
          key: "stream_id",
          value: this.currentStreamId ? this.currentStreamId : this.$route.params.id,
        });
        details.push({
          key: "ale_id",
          value: this.$route.params.aleId ? this.$route.params.aleId : null,
        });
        details.push({
          key: "localisation",
          value: this.$route.params.localisation ? this.$route.params.localisation : null,
        });
        details.push({ key: "reaction_id", value: reaction.id });
        details.push({ key: "element_type", value: this.currentElementType });
        details.push({ key: "element_id", value: this.currentElementId });
      }

      let data = {
        main: {
          action: "submitted",
          objectId: this.block.id,
          objectType: "block",
        },
        details: details,
      };

      await this.setBlockReactions({
        blockId: this.block.id,
        reactionId: this.reactionValid(reaction.id) ? reaction.id : null,
        reactionSavedId: this.existSelectedReaction
          ? this.blockReactionsSelected(this.block.id).id
          : null,
      });

      if (this.reactionValid(reaction.id)) await this.submitActivity({ data: [data] });
      else this.deleteActivity(data);

      trackEvent("ReactionSelect", {
        "block-id": this.block.id,
        "element-type": this.currentElementType,
        "element-id": this.currentElementId,
        "block-type": this.block["__component"],
        "reaction-id": reaction.id,
        "reaction-icon": this.reactionList.reactions.find((r) => r.id === reaction.id).icon,
        "reaction-name": this.reactionList.reactions.find((r) => r.id === reaction.id).name,
      });
    },
    reactionButtonClicked() {
      trackEvent("AddReaction", {
        "block-id": this.block.id,
        "element-type": this.currentElementType,
        "element-id": this.currentElementId,
        "block-type": this.block["__component"],
      });
    },
    reactionValid(valueToCheck) {
      return [undefined, null, this.reactionList.notSelected].indexOf(valueToCheck) === -1;
    },
  },
  computed: {
    ...mapGetters({
      reactionList: "moodsAndReactions/getReactionList",
      activeReactionList: "moodsAndReactions/getActiveReactionList",
      getReaction: "moodsAndReactions/getReaction",
      blockReactionsCounters: "moodsAndReactions/getBlockReactionsCounters",
      blockReactionsSelected: "moodsAndReactions/getBlockReactionsSelected",
      currentElementType: "streams/getCurrentElementType",
      currentElementId: "streams/getCurrentElementId",
      currentStreamId: "streams/getCurrentStreamId",
    }),
    parseComponent() {
      let component = "";
      switch (this.block.__component) {
        case "atoms.image":
          if (this.block.position === "left" || this.block.position === "right") {
            component = "text-with-image-horizontal";
          } else {
            component = "text-with-image-vertical";
          }
          break;
        case "atoms.infographic":
          component = "infographic";
          break;
        case "atoms.video":
          component = "wistia-video";
          break;
        case "atoms.title":
          component = "title-block";
          break;
        case "accordions.accordion-block":
          component = "accordion-block";
          break;
        case "atoms.text":
          component = "text-block";
          break;
        case "quotes.quote-block":
          if (this.block.quote_item.length === 1) {
            component = "quote-block";
          } else {
            component = "quote-carousel-block";
          }
          break;
        case "atoms.multime":
          component = "multi-me-block";
          break;
        case "prompts.prompts-block":
          component = "prompt-group";
          break;
        case "community.collective-room":
          component = "collective-room-block";
          break;
        default:
          console.log(`component not implemented! ${this.block.__component}`);
          break;
      }
      return component;
    },
    isDarkBg() {
      return this.color === "primary-block";
    },
    defaultDropdownButton: function () {
      return `${this.reactionList.dropdown.icon} <small>${this.reactionList.dropdown.name}</small>`;
    },
    existSelectedReaction: function () {
      return this.blockReactionsSelected(this.block.id);
    },
    hasReactionList() {
      return this.reactionList.reactions.length > 0;
    },
    buttonValue() {
      if (this.existSelectedReaction) {
        let emotion = this.getReaction(this.existSelectedReaction.id);
        return `${emotion.icon} ${emotion.name}`;
      } else return this.trans("mood-reactions.emotion_button_v2");
    },
    showReactions() {
      return this.block.reactions && this.hasReactionList && !this.isInModal;
    },
  },
};
</script>

<style scoped lang="scss">
.single-stream-block {
  width: 100%;
  padding-top: 0 !important;
  padding-bottom: 100px !important;
}

.block-top {
  padding-top: 80px;
}

.block-container {
  padding-bottom: 80px;
}

#reactions-counter {
  li {
    font-size: 12px;
    &:not(:last-child)::after {
      content: "";
      height: 3px;
      width: 3px;
      margin: 0 6px;
      border-radius: 50%;
      display: inline-block;
      align-self: center !important;
    }
  }
}
</style>
